module.exports = __webpack_public_path__ + "static/img/01.618754c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/gamify/tutorial/01.svg
// module id = 0Dr3
// module chunks = 13